export default "__VITE_ASSET__36ab42e5__"